import _ from 'lodash';
import postal from 'postal';

import lineLimiting from './line-limiting';
import breakpoints from '../shared/breakpoints';
import VideoSwoosher from '../shared/video-swoosher/video-swoosher';
import SwooshableVimeoVideo from '../shared/video-swoosher/swooshable-vimeo-video';
import SwooshableYouTubeVideo from '../shared/video-swoosher/swooshable-youtube-video';
import SwooshableWistiaVideo from '../shared/video-swoosher/swooshable-wistia-video';

// NOTE this only runs once - if the sidebar is resized horizontally the text
// doesn't update. It could, but that is a future refinement (have to find a
// way around having to constantly rerun the loop each time the resize event
// is triggered).
function limitTrendingWireHeadersToTwoLines() {
  $('.sidebar-trending ul li h3').each((i, element) => {
    lineLimiting(
      2,
      $ele => $ele.find('a').text(),
      ($ele, text) => $ele.find('a').text(text),
    )($(element));
  });
}

function setUpVideoSwoosher() {
  const $sidebarVideos = $('section.sidebar .sidebar-videos');

  if (!$sidebarVideos.length) return;

  const swoosher = new VideoSwoosher($sidebarVideos);

  $('[data-event-type="youtube"] iframe').each((index, iframe) => swoosher.register(new SwooshableYouTubeVideo(iframe)));
  $('[data-event-type="vimeo"] iframe').each((index, iframe) => swoosher.register(new SwooshableVimeoVideo(iframe)));
  $('[data-event-type="wistia"] iframe').each((index, iframe) => swoosher.register(new SwooshableWistiaVideo(iframe)));

  // dynamically register new videos
  postal.subscribe({
    channel: 'commands.columnar',
    topic: 'register-youtube-video',
    callback: data => swoosher.register(new SwooshableYouTubeVideo(data.iframe)),
  });
  postal.subscribe({
    channel: 'commands.columnar',
    topic: 'register-vimeo-video',
    callback: data => swoosher.register(new SwooshableVimeoVideo(data.iframe)),
  });
  postal.subscribe({
    channel: 'commands.wistia',
    topic: 'register-wistia-video',
    callback: data => swoosher.register(new SwooshableWistiaVideo(data.iframe)),
  });

  // disable video swooshing up to medium (where the sidebar gets moved or removed)
  if (breakpoints.upTo_medium()) {
    swoosher.disable();
  }

  $(window).on('resize', _.throttle(() => (breakpoints.largerThan_medium() ? swoosher.enable() : swoosher.disable()), 100));
}

export default function bootstrap() {
  $(() => {
    limitTrendingWireHeadersToTwoLines();
    setUpVideoSwoosher();
  });
}
